module.exports = __webpack_public_path__ + "img/ua.7011cb9d.svg";